module.exports = __webpack_public_path__ + "static/media/ninos-1.449c5278.jpg";